import { WebMediaQuery } from '@aperza/ui';
import { AppConfigService } from '@aperza/util';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
export default class NavBarItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSubMenu: true,
        };
    }
    onMouseOver(e) {
        if (!this.props.disabled && this.props.onMouseOver) {
            this.props.onMouseOver();
            e.preventDefault();
        }
    }
    render() {
        const { title, shortTitle, imageIconUrl, url, className, icon, openOnNewTab, showExternalLink, disabled, onMouseLeave } = this.props;
        const { showSubMenu } = this.state;
        let display = 'none';
        if (showSubMenu) {
            display = 'block';
        }
        const selectedShortTitle = shortTitle || title;
        const href = AppConfigService.getHref();
        const selected = href.startsWith(url || '');
        const renderLogo = (icon) => {
            if (icon === 'imageIconUrl' && imageIconUrl) {
                return React.createElement("img", { src: imageIconUrl, alt: "icon" });
            }
            if (typeof icon === 'string' || icon instanceof String) {
                return React.createElement("div", { className: `naviLinkLogo ${icon}` });
            }
            return (React.createElement("div", { style: { marginRight: '4px' } },
                React.createElement(FontAwesomeIcon, { ...icon })));
        };
        return (React.createElement("div", { onMouseOver: this.onMouseOver.bind(this), onMouseLeave: onMouseLeave },
            React.createElement("a", { className: `naviLink ${className || ''} ${selected ? 'selected' : ''} ${disabled ? 'aw-disabled' : ''}`, href: disabled ? '#' : url, target: openOnNewTab ? '_blank' : '_self', rel: "noreferrer" },
                icon && renderLogo(icon),
                React.createElement(WebMediaQuery, { desktopOnly: true }, title),
                React.createElement(WebMediaQuery, { mobileOnly: true }, selectedShortTitle),
                showExternalLink && React.createElement("div", { style: { marginLeft: '2px' } },
                    React.createElement(FontAwesomeIcon, { icon: faExternalLink })))));
    }
}
NavBarItem.propTypes = {
    title: PropTypes.any.isRequired,
    shortTitle: PropTypes.any,
    icon: PropTypes.any,
    url: PropTypes.string,
    openOnNewTab: PropTypes.bool,
    showExternalLink: PropTypes.bool,
    className: PropTypes.string,
    onMouseOver: PropTypes.func,
    onMouseLeave: PropTypes.func,
    disabled: PropTypes.bool,
};
